import './AdminHeader.css'

export default function AdminHeader() {
  return <div className='AdminHeader'>ADMIN MODE - EDITING ENABLED</div>
}
